import 'focus-visible'

import { disableBodyScrolling, enableBodyScrolling } from './helpers'

import NavMenu from './nav-menu'
import Search from './search'
import CookieLayer from './cookie-layer'
import Popover from './popover'
import * as ScrollTop from './scroll-top'
import LangSwitch from './lang-switch'
import Ticker from './ticker'

const Global = function () {

	let elements, navMenu, search, cookieLayer, userMenu, langMenu, headerColor

	function init() {
		elements = {
			nav: {
				menu: document.getElementById('page-nav-menu'),
				trigger: document.getElementById('menuButton'),
			},
			search: {
				element: document.getElementById('search-results-menu'),
				trigger: document.getElementById('meta-suche-link'),
			},
			cookieLayer: {
				element: document.getElementById('cookie-layer'),
				trigger: document.querySelectorAll('[data-cookie-layer-trigger]'),
			},
			userMenu: {
				element: document.getElementById('meta-user-menu'),
				trigger: document.querySelectorAll('#meta-user-link, #level1-user-link'),
			},
			langMenu: {
				element: document.getElementById('meta-lang-menu'),
				trigger: document.querySelectorAll('#meta-lang-link, #level1-lang-link'),
			}
		}

    ScrollTop.init()
    LangSwitch.init()
    Ticker.init()

		if (elements.nav.menu) {
			navMenu = new NavMenu(elements.nav.menu, {
				navLevelSelector: '.navmenu, .navmenu-level',
				trigger: elements.nav.trigger,
				await: ['transitionend', ({ target }) => target.classList.contains('navmenu')],
				onBeforeShow: disableBodyScrolling,
				onBeforeHide: enableBodyScrolling,
			})
		}

		if (elements.search.element) {
			search = new Search(elements.search.element, {
				trigger: elements.search.trigger,
				await: ['transitionend'],
				onBeforeShow: disableBodyScrolling,
				onBeforeHide: enableBodyScrolling,
			})
		}

    if (elements.cookieLayer.element) {
      // Do not show in iFrames
      if (window.self !== window.top) {
        elements.cookieLayer.element.setAttribute('data-cookie-layer-disable', true)
      }

			cookieLayer = new CookieLayer(elements.cookieLayer.element, {
				trigger: elements.cookieLayer.trigger,
				await: ['transitionend', ({ target }) => target.classList.contains('cookie-layer__content')],
				onBeforeShow: disableBodyScrolling,
				onBeforeHide: enableBodyScrolling,
			})
		}

		if (elements.userMenu.element) {
			userMenu = new Popover(elements.userMenu.element, {
				trigger: elements.userMenu.trigger,
				await: 'transitionend',
			})
		}

		if (elements.langMenu.element) {
			langMenu = new Popover(elements.langMenu.element, {
				trigger: elements.langMenu.trigger,
				await: 'transitionend',
			})
		}

    const urlParams = new URLSearchParams(window.location.search);
    const disableAdaptiveHeaderColor = urlParams.get('disableAdaptiveHeaderColor');

    if (disableAdaptiveHeaderColor) {
      window.DISABLE_ADAPTIVE_HEADER_COLOR = true
    }

		if (!window.DISABLE_ADAPTIVE_HEADER_COLOR) {
			// The header color module is quite heavy in boundle size so we lazyload it
			import('./header-color').then(({ default: module }) => {
				headerColor = module
				headerColor.init()
			})
		}
	}

	return {
		init,
		get navMenu() {
			if (!navMenu) {
				console.warn('navMenu not initialized')
			}
			return {
				open: () => navMenu && navMenu.show(),
				close: () => navMenu && navMenu.hide(),
				get isOpen() {
					return navMenu ? !navMenu.hidden : false
				}
			}
		},
		get search() {
			if (!search) {
				console.warn('search not initialized')
			}
			return {
				open: () => search && search.show(),
				close: () => search && search.hide(),
				get isOpen() {
					return search ? !search.hidden : false
				}
			}
		},
		get cookieLayer() {
			if (!cookieLayer) {
				console.warn('cookieLayer not initialized')
			}
			return {
				open: () => cookieLayer && cookieLayer.show(),
				close: () => cookieLayer && cookieLayer.hide(),
				get isOpen() {
					return cookieLayer ? !cookieLayer.hidden : false
				}
			}
		},
		get userMenu() {
			if (!userMenu) {
				console.warn('userMenu not initialized')
			}
			return {
				open: () => userMenu && userMenu.show(),
				close: () => userMenu && userMenu.hide(),
				get isOpen() {
					return userMenu ? !userMenu.hidden : false
				}
			}
		},
		get langMenu() {
			if (!langMenu) {
				console.warn('langMenu not initialized')
			}
			return {
				open: () => langMenu && langMenu.show(),
				close: () => langMenu && langMenu.hide(),
				get isOpen() {
					return langMenu ? !langMenu.hidden : false
				}
			}
		},
		get headerColor() {
			if (!headerColor) {
				console.warn('headerColor not initialized')
			}
			return {
				set debug(value) {
					headerColor.debug = value
				}
			}
		}
	}
}()

export default Global
